/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { Action, isType } from 'typescript-fsa';
import { Album, Song } from '../../../services/playlist';
import { setSong, songSetAlbums } from './actions';

export interface SongEditState {
    song: Song;
    albums: Album[];
}

const initialSongEditState: SongEditState = {
    song: {
        id: '',
        artist: '',
        name: '',
        remark: '',
        audioUrl: ''
    },
    albums: []
};

export const songEditReducer = (state: SongEditState = initialSongEditState, action: Action<{}>): SongEditState => {

    if (isType(action, setSong)) {
        let song: Song = action.payload;
        return Object.assign({}, state, {song: song});
    } else if (isType(action, songSetAlbums)) {
        return {...state, albums: action.payload };
    }

    return state;
};